import {
  NEW_PROJECT,
  EDIT_PROJECT,
  NEXT_STAGE,
  NEW_PROJECT_FORM_VALUE_CHANGE,
  NEW_PROJECT_CURRENT_PAGE_SET,
  NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE,
  NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE,
  NEW_PROJECT_NEW_CLIENT_MODAL_SHOW,
  NEW_PROJECT_NEW_CLIENT_FORM_CLEAN,
  NEW_PROJECT_NEW_BUILDING_MODAL_SHOW,
  NEW_PROJECT_NEW_BUILDING_FORM_CLEAN,
  EDIT_PROJECT_FORM_SET_VALUES,
} from 'components/admin/projects/creation/store/action-types';

const stages = [
  'gc-selection',
  'client-selection',
  'building-selection',
  'success',
];

const initialState = {
  currentPage: 1,
  currentStage: 'gc-selection',
  projectForm: {
    generalContractorId: null,
    clientId: null,
    buildingId: null,
    number: '',
    name: '',
    sqFootage: '',
    bidDueDate: '',
    advancedDocumentView: false,
  },
  clientForm: {
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
  },
  buildingForm: {
    name: '',
    streetAddress1: '',
    streetAddress2: '',
    city: '',
    state: '',
    zip: '',
  },
  showNewClientModal: false,
  showNewBuildingModal: false,
};

export default function newProjectUiReducer(state = initialState, action) {
  switch (action.type) {
    case NEW_PROJECT:
      return initialState;

    case EDIT_PROJECT:
      return {
        ...initialState,
        currentStage: 'client-selection',
      };

    case NEW_PROJECT_CURRENT_PAGE_SET:
      return {
        ...state,
        currentPage: action.payload,
      };

    case NEXT_STAGE:
      return {
        ...state,
        currentStage: stages[stages.indexOf(state.currentStage) + 1],
      };

    case NEW_PROJECT_FORM_VALUE_CHANGE:
      return {
        ...state,
        projectForm: {
          ...state.projectForm,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case EDIT_PROJECT_FORM_SET_VALUES:
      return {
        ...state,
        projectForm: {
          ...state.projectForm,
          clientId: action.payload.client.id,
          buildingId: action.payload.building.id,
          number: action.payload.number,
          name: action.payload.name,
          sqFootage: action.payload.sq_footage,
          bidDueDate: action.payload.bid_due_date,
          advancedDocumentView: action.payload.advanced_document_view,
        },
      };

    case NEW_PROJECT_CLIENT_FORM_VALUE_CHANGE:
      return {
        ...state,
        clientForm: {
          ...state.clientForm,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case NEW_PROJECT_BUILDING_FORM_VALUE_CHANGE:
      return {
        ...state,
        buildingForm: {
          ...state.buildingForm,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case NEW_PROJECT_NEW_CLIENT_MODAL_SHOW:
      return {
        ...state,
        showNewClientModal: action.payload,
      };

    case NEW_PROJECT_NEW_CLIENT_FORM_CLEAN:
      return {
        ...state,
        clientForm: initialState.clientForm,
      };

    case NEW_PROJECT_NEW_BUILDING_MODAL_SHOW:
      return {
        ...state,
        showNewBuildingModal: action.payload,
      };

    case NEW_PROJECT_NEW_BUILDING_FORM_CLEAN:
      return {
        ...state,
        buildingForm: initialState.buildingForm,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/store/reducers.ui.js